import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { filter, map, takeUntil, tap } from 'rxjs/operators';
import { User } from '../models/User';
import { FeatureFlagService, FLAGS } from '../services/feature-flag.service';
import { UserService } from '../services/user.service';

@Component({
	selector: 'app-passes',
	templateUrl: './passes.component.html',
	styleUrls: ['./passes.component.scss'],
})
export class PassesComponent implements OnInit, OnDestroy {
	effectiveUser: User;
	isStaff = false;
	isStudent = false;
	hasSchedulesFF = false;
	private destroy$: Subject<any> = new Subject();

	constructor(private userService: UserService, private featureFlags: FeatureFlagService) {}

	ngOnInit() {
		// get the user and populate NgRx with user data
		this.userService.effectiveUser$
			.pipe(
				tap((effectiveUser) => {
					this.effectiveUser = effectiveUser;
					this.isStaff = this.effectiveUser.isStaff();
					this.isStudent = this.effectiveUser.isStudent();

					this.hasSchedulesFF = this.featureFlags.isFeatureEnabledV2(FLAGS.Schedules);
				}),
				takeUntil(this.destroy$)
			)
			.subscribe();
	}

	ngOnDestroy() {
		this.destroy$.next(undefined);
		this.destroy$.complete();
	}
}
